import { Component, OnInit } from '@angular/core';
import { SwitchStatusTimesService } from '../../shared/services/switch-status-times.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BusyService } from '../../shared/services/busy.service';
import { SwitchStatusTimes } from '../../shared/models/SwitchStatusTimes';
import { AlertService } from '../../shared/services/alert.service';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-end-time',
  templateUrl: './end-time.component.html',
  styleUrls: ['./end-time.component.scss']
})
export class EndTimeComponent implements OnInit {
  busy = false;
  regionId: number;
  displayEditDialog = false;
  editModel: any = {};
  model = {
    switchStatusTimes: []
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private busyService: BusyService,
    private switchStatusTimesService: SwitchStatusTimesService,
    private alertService: AlertService
  ) {
    const currentUser = AuthService.currentUser();
    if (!currentUser.isInRole(['sysadmin', 'superuser'])) {
      this.router.navigate(['/orgedit/' + currentUser.organizationId]);
    } else {
      this.regionId = currentUser.regionId;
    }

    this.busyService.initHandler('endTimeCmp', busy => {
      this.busy = busy;
    });
  }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.loadData();
    });
  }

  loadData() {
    this.busyService
      .follow('endTimeCmp', this.switchStatusTimesService.get(this.regionId))
      .subscribe(times => {
        this.model.switchStatusTimes = times;
      });
  }

  editTime(time) {
    this.displayEditDialog = true;
    this.editModel = new SwitchStatusTimes(time);
  }

  save() {
    const newItem = new SwitchStatusTimes(this.editModel);

    if (this.editModel.cTodayEndTime instanceof Date) {
      newItem.cTodayEndTime = new Date(this.editModel.cTodayEndTime)
        .toTimeString()
        .slice(0, 5);
      newItem.nTodayEndTime = +newItem.cTodayEndTime.replace(':', '');
    }
    if (this.editModel.cTomorrowStartTime instanceof Date) {
      newItem.cTomorrowStartTime = new Date(this.editModel.cTomorrowStartTime)
        .toTimeString()
        .slice(0, 5);

      newItem.nTomorrowStartTime = +newItem.cTomorrowStartTime.replace(':', '');
    }

    this.busyService
      .follow('endTimeCmp', this.switchStatusTimesService.save(newItem))
      .subscribe(res => {
        this.alertService.showSuccess(
          // tslint:disable-next-line:quotemark
          "'Today End Time' was updated successfully."
        );
        this.displayEditDialog = false;
        this.loadData();
      });
  }

  cancel() {
    this.editModel = {};
    this.displayEditDialog = false;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/authorized/end-time/end-time.component.ts